import cipraLogo from "../../res/ProviderLogos/cipra_logo.jpg";

import {Button, Input, SpaceBetween, Spinner} from "@cloudscape-design/components";
import {useEffect, useState, useCallback} from "react";
import { UnsubscribeData } from "../../data/UnsubscribeData";
import {support_contact} from "../../res/support"
const support: JSX.Element = support_contact
export function UnsubscribeEntryPage(): JSX.Element {

    const [emailValue, setEmailValue] = useState<string>('')
    const [emailTip, setEmailTip] = useState<JSX.Element | undefined>(undefined)
    const [showBlock, setShowBlock] = useState<boolean>(true)
    const [submitWaiting, setSubmitWaiting] = useState<boolean>(false)

    const submit = useCallback((): void => {
        if (emailValue.length === 0){
            setEmailTip(
                <div>
                    <p>Please enter your email.</p>
                </div>
                )
            return
        }
        setSubmitWaiting(true)
        // Get the current URL query parameters
        const queryParams = new URLSearchParams(window.location.search);
        // Retrieve the value of auto_unsub
        const autoUnsubParam = queryParams.get('auto_unsub');

        UnsubscribeData.instance.isUserRegistered(
            emailValue,
            (data) => {
                UnsubscribeData.instance.sendUnsubscribeEmail(
                    emailValue,
                    data.pid,
                    autoUnsubParam ?? "",
                    (data) => {
                        setSubmitWaiting(false)
                        setShowBlock(false);
                        setEmailTip(
                            <div>
                                {data}
                            </div>
                        )
                    },
                    () =>{
                        setSubmitWaiting(false)
                        setEmailTip(
                            <div>
                                <b>{emailValue}</b><b>{ data.pid}</b>Request cannot be processed at the moment.
                            </div>
                        )
                    }
                )
            },   // send email
            () => {
                setSubmitWaiting(false)
                setEmailTip(
                <div>
                    <p>Cannot find account with email address <b>{emailValue}</b></p>
                    {support}
                </div>
            )}
        )
    }, [emailValue])

    useEffect(() => {
        const enterKeyDown = (event: KeyboardEvent) => {
            if(event.key !== 'Enter') return
            submit()
        }

        document.addEventListener("keydown", enterKeyDown, false);

        return () => {
            document.removeEventListener("keydown", enterKeyDown, false);
        };
    }, [submit]);

    return <div className="center-screen">
        <div className="glow-border page-container" style={{maxWidth: "330px"}}>
            <SpaceBetween size='m' direction='vertical'>
                <img src={cipraLogo} alt='cipra logo' width='90%' className='line-align-center'/>
                <h2 className='line-align-center'>Unsubscribe from CIPRA.ai</h2>
                {
                    (showBlock) &&
                    <SpaceBetween size='m' direction='vertical'>
                        <SpaceBetween size='m' direction='horizontal'>
                            <div>Email</div>
                        </SpaceBetween>
                        <Input onChange={({detail}) => setEmailValue(detail.value)}
                               value={emailValue}
                               type="email"
                               placeholder="Email Address"
                        ></Input>
                        {(emailTip) && <p className='tip-text'>{emailTip}</p>}
                        <div className='line-align-center'>
                            <Button variant='primary' onClick={submit} disabled={submitWaiting}>
                            {
                            submitWaiting && <Spinner />
                            }
                                Unsubscribe
                            </Button>
                        </div>
                    </SpaceBetween>
                }
                {
                    (!showBlock) &&
                    <div>
                        <p>{emailTip}</p>
                    </div>
                }
            </SpaceBetween>
        </div>
    </div>
}
export default UnsubscribeEntryPage;
